// extracted by mini-css-extract-plugin
export default {"wrapper":"Terms_wrapper__IXq8q"};